import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/siteInfo';
import { categories } from '@/mocks/categories';

const footerLinks = {
  快速导航: [
    { label: '首页', path: '/' },
    { label: '平台入门', path: '/category/platform-guide' },
    { label: '使用技巧', path: '/category/usage-tips' },
    { label: '安全指南', path: '/category/security-guide' },
    { label: '最新动态', path: '/category/latest-news' },
  ],
  帮助支持: [
    { label: '常见问题', path: '/category/faq-common' },
    { label: '关于我们', path: '/about' },
    { label: '联系我们', path: '/about#contact' },
    { label: '隐私政策', path: '#' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 text-xl font-heading font-semibold text-background-50 mb-4 cursor-pointer">
              <span className="w-8 h-8 bg-primary-500 rounded-lg flex items-center justify-center">
                <i className="ri-sun-line text-background-50 text-lg"></i>
              </span>
              {siteInfo.name}
            </Link>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              您值得信赖的首选平台，提供流畅稳定的在线体验。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200 cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200 cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200 cursor-pointer" aria-label="邮箱">
                <i className="ri-mail-line"></i>
              </a>
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h3 className="text-sm font-semibold text-background-50 mb-4">{title}</h3>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">联系方式</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-sm text-background-400">
                <i className="ri-phone-line mt-0.5 text-background-500"></i>
                <span>{siteInfo.phone}</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-background-400">
                <i className="ri-mail-line mt-0.5 text-background-500"></i>
                <span>{siteInfo.email}</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-background-400">
                <i className="ri-map-pin-line mt-0.5 text-background-500"></i>
                <span>{siteInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有
            </p>
            <p className="text-xs text-background-500">
              <a href="#" className="hover:text-background-300 transition-colors cursor-pointer">隐私政策</a>
              <span className="mx-2">|</span>
              <a href="#" className="hover:text-background-300 transition-colors cursor-pointer">服务条款</a>
              <span className="mx-2">|</span>
              <a href="#" className="hover:text-background-300 transition-colors cursor-pointer">网站地图</a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}